import { IErrorsStore } from '../../../errors/store';
import { IAdminRoundFormatAwardsStore } from '../store';

import api, { request } from '../../../../api';
import { groupBy } from '../../../../contrib/utils';
import { IStore } from '../../../index';

export const get = async (
  state: IStore,
  roundId: number | string,
  leaderboardId: number,
  force?: boolean
): Promise<{ adminRoundFormatAwards?: IAdminRoundFormatAwardsStore; errors?: IErrorsStore }> => {
  if (
    state.adminRoundFormatAwards[Number(roundId)] &&
    state.adminRoundFormatAwards[Number(roundId)][leaderboardId] &&
    !force
  ) {
    return {
      adminRoundFormatAwards: state.adminRoundFormatAwards
    };
  }

  const response = await request.get(api.admin.roundFormatAwards(leaderboardId));

  if (response.error) {
    return {
      errors: {
        adminRoundFormatAwards: { msg: 'Error retrieving the Round Format Awards List.' }
      }
    };
  }

  return {
    adminRoundFormatAwards: {
      ...state.adminRoundFormatAwards,
      [roundId]: {
        ...state.adminRoundFormatAwards[Number(roundId)],
        [leaderboardId]: groupBy(response, 'user')
      }
    }
  };
};
